import { render, staticRenderFns } from "./OrderStatusesList.vue?vue&type=template&id=0333f788&scoped=true"
import script from "./OrderStatusesList.vue?vue&type=script&lang=js"
export * from "./OrderStatusesList.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusesList.vue?vue&type=style&index=0&id=0333f788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0333f788",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fcomponents%2Freusable-components%2Forder-statuses-list%2FOrderStatusesList.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports